<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:topLeft>
      <!--Back Button-->
      <v-btn
        outlined 
        color="white"
        @click="$router.go(-1)"
        active-class="no-active"
        class="mb-4 liiblack"
        :block="$vuetify.breakpoint.xsOnly? true:false"
        :class="$vuetify.breakpoint.smAndDown? 'mt-3':'mt-0'"
      >
        <v-icon small class="mr-4"> mdi-arrow-left </v-icon>
        {{$t('btntxt.prev_page')}}
      </v-btn>
    </template>

    <template v-slot:title>
      <h1 v-if="status_okay" class='text-h1 mb-0'>{{$t('database.appealhistitle', [text_to_display_for_history, caseno])}}</h1>
      <!--alert for error-->
      <v-alert 
        v-else-if="!overlay"
        dense text
        type="error"
        class="mt-3 mb-4"
        icon="mdi-alert-outline"
      > 
        {{$t('error.page_unavailable')}}
      </v-alert>
    </template>

    <template v-slot:mainPanel>
      <div class="mb-5" v-for="(c, i) in appealhistory" :key="i">
        <h3 class='text-h3 navlink--text caseno' :class="$vuetify.breakpoint.xsOnly?'mb-1':'mb-2'">{{c.act}}</h3>
        <v-data-table
          :key="'ah-table-' + i"
          :items="c.judgments"
          :headers="headers"
          :items-per-page="-1"
          hide-default-footer 
          :hide-default-header="$vuetify.breakpoint.xsOnly?true:false"
          disable-sort
          dense
          class="ahtable"
          :class="$vuetify.breakpoint.xsOnly?'mb-7':'ml-5'"
        >
          <!--<template v-slot:[`item.lang`]="{ item }">
              <span v-html="judgment_lang(item.lang)"></span>
          </template>
          <template v-slot:[`item.date`]="{ item }">
              <span v-html="display_date(item.date)"></span>
          </template>-->
          <template v-slot:item="{item}">
            <tr v-if="$vuetify.breakpoint.smAndUp" @click="$vuetify.breakpoint.smAndDown? goto_jud(item) :'' " ><!--desktop TOC-->
              <td class="pr-1">
                <span @click="$vuetify.breakpoint.smAndDown?'':goto_jud(item)" v-html="item.neutral"></span>
              </td>
              <td class="pr-1">
                <span @click="$vuetify.breakpoint.smAndDown?'':goto_jud(item)" v-html="display_date(item.date)"></span>
              </td>
              <td class="pr-1">
                <span @click="$vuetify.breakpoint.smAndDown?'':goto_jud(item)" v-html="judgment_lang(item.lang)"></span>
              </td>
              <td>
                <span @click="$vuetify.breakpoint.smAndDown?'':goto_jud(item)" v-html="item.remarks"></span>
              </td>
            </tr>
            <tr v-else @click="goto_jud(item)"> <!--mobile TOC-->
              <td class="mobiledt-td py-2">
              <span class="mobiledt_label mr-4" v-html="item.neutral"> </span> 
              <span class="mr-4" v-html="item.lang"> </span> 
              <span v-html="display_date(item.date)"></span><br>
              <span class="mobiledt_subinfo mobiledt_remarks" v-html="item.remarks"></span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>

      <!-- loading overlay-->
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
    </template>

  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import api from '@/scripts/api'
  import datehelper from '@/scripts/datehelper'
  export default {
    name:'AppeahHistory',
    components:{
      ThreeColumn
    },
    data(){
      return {
        overlay:  true,
        status_okay: false,
        appealhistory: [],
      }
    },
    methods:{
      display_date: datehelper.display_date,
      judgment_lang(lang){
        return this.$i18n.t(`langs.short.${lang.toLowerCase()}`)
      },
      async get_appealhistory(){
        this.overlay = true
        try {
          this.appealhistory = await api.get_appeal_history(this.caseno)
          this.status_okay = true
        } catch {
          this.status_okay = false
        } finally {
          this.overlay = false
        }
      },
      goto_jud(item, a){
        window.open(item.path, '_blank')
      },
    },
    computed:{
      paths(){
        return [
          {text: 'HKLII', disabled: false, href: {name: 'home'}},
          {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
        ]
      },
      caseno(){
        return this.$route.params.type + this.$route.params.num + '/' + this.$route.params.year
      },
      text_to_display_for_history(){
        return this.appealhistory.length === 1 ? this.$t('database.case_a') : this.$t('database.appeal')
      },
      headers(){
        return [
          {text: this.$i18n.t('search.advs.neutral'), value: 'neutral', width: '25%'},
          {text: this.$i18n.t('database.date'), value: 'date', width: '22%'},
          {text: this.$i18n.t('database.lang'), value: 'lang', width: '9%'},
          {text: this.$i18n.t('tbhead.ap_remarks'), value: 'remarks'}
        ]
      },
      /*windowTitle(){
        return this.$i18n.t('database.appealhistitle', [this.text_to_display_for_history, this.caseno]).concat(' | HKLII')
      }*/
    },
    /*watch: {
      windowTitle: function(){
        window.document.title = this.windowTitle
      }
    },*/
    mounted(){
      this.get_appealhistory()
    },
    metaInfo(){
      return{
        title: this.$i18n.t('database.appealhistitle', [this.text_to_display_for_history, this.caseno]),
      }
    },
  }
</script>

<style>
  .v-btn--active.no-active:not(:focus):not(:hover)::before{                                                                             
    opacity: 0 !important; /*keep nav button color*/
  }
  .ahtable tr{
    cursor: pointer;
    padding-left: 3px !important;
  }
  .ahtable thead{ 
    background: var(--v-l_case-base);
  }
  .ahtable th{ 
      height: 30px !important;
      padding-top: 3px !important;
      padding-bottom: 3px !important;
      padding-left: 5px !important;
      vertical-align: bottom;
  }
  .ahtable td{
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    padding-left: 5px !important;
    vertical-align: top;
  }

  .caseno{
    letter-spacing: 0.13em !important;
  }


  /*mobile formatting (XS)*/
  .mobiledt_label{
    background-color: var(--v-l_case-base);
    color: var(--v-liiblack-base);
    padding-left:8px;
    padding-right:8px;
    border-radius: 20px;
  }

  .mobiledt_remarks{
    display: block;
    padding-left: 4pt;
    padding-top: 3px;
  }

  .mobiledt-td{
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
  }

</style>
